import React from 'react';
import { IconButton } from '@material-ui/core';
import { Backspace, Undo } from '@material-ui/icons';
// import { useDispatch } from "react-redux";
import { changePaxStatus } from '../../../store/dcs'
import _ from 'lodash'


export const NoShow = (props) => {
  const {pax, status, dispatch} = props;
  // NOTE // ETStatus: "O" is open, "F" is flown, "U" is no-show, "C" is checked in

  const handleNoShow = (pax, newStatus) => {
    const editData = {couponNumber: pax.TicketCouponNumber, newStatus, paxNumber: pax.PaxNumber, ticketNumber: pax.TicketNumber}
    const payload = {editData, rloc: pax.PNRRefNo, type: 'noShow'}
    dispatch(changePaxStatus(payload))
  };

  if(status === "U") {
    return (
      <div>
        <IconButton variant="contained" onClick={() => (handleNoShow(pax, 'O'))}>
          <Undo />
        </IconButton>
      </div>
    )
  }
  
  return (
    <div>
      <IconButton variant="contained" onClick={() => (handleNoShow(pax, 'U'))} disabled={status === "F"}>
        <Backspace />
      </IconButton>
    </div>
  )
}